import React from "react"
import * as textStyles from "./text.module.scss"

export default function Text(props) {
  return (
    <div className={`${[textStyles.container, "animate"].join(" ")}`} dangerouslySetInnerHTML={{__html: props.content}}></div>
  )
}